<template>
  <footer>
    <div class="wrap">
      <div class="middle">
        <div class="left  footer-festivals">
          <span class="title">Другие фестивали:</span>
          <a class="footer-link" :href="`${$3dParty.berlin2019.link}`" target="_blank">
            <span>{{ $3dParty.berlin2019.title }}</span>
          </a>
          <a class="footer-link" :href="`${$3dParty.cannes.link}`" target="_blank">
            <span>{{ $3dParty.cannes.title }}</span>
          </a>
          <a class="footer-link" :href="`${$3dParty.kinotavr2019.link}`" target="_blank">
            <span>{{ $3dParty.kinotavr2019.title }}</span>
          </a>
          <a class="footer-link" :href="`${$3dParty.venice2019.link}`" target="_blank">
            <span>{{ $3dParty.venice2019.title }}</span>
          </a>
          <a class="footer-link" :href="`${$3dParty.kinotavr2020.link}`" target="_blank">
            <span>{{ $3dParty.kinotavr2020.title }}</span>
          </a>
        </div>
      </div>
      <div class="middle">
        <div class="left">
          <span class="title">Редакторы:</span>
          <span>
            Егор Беликов,<br>
            Виолетта Палий,<br>
            Алексей Филиппов
          </span>
          <div class="left">
            <span class="title">
              <br>Дизайнеры:
            </span>
            <a href="https://dribbble.com/olgoosh" target="_blank">Чупахина Оля,</a>
            <a target="_blank">Егор Беликов</a>
          </div>
        </div>
        <div class="right">
          <span class="title">Logos and stills:</span>
          <span class="footer-info">© Internationale Filmfestspiele Berlin</span>
        </div>
      </div>
      <div class="bottom">
        <span
          class="b-copyright"
        >© Журнал «Искусство кино», {{ $moment() | moment('Y') }}<br/>Свидетельство о регистрации ЭЛ № ФС 77-77032 от 06 ноября 2019 года</span>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "b-footer",
  inject: ["$3dParty"]
};
</script>

<style scoped lang="sass">
.footer-festivals
  display: flex
  flex-direction: column
.footer-link
  font-size: 14px
  line-height: 1.57
  font-family: Pragmatica
  &:hover
    opacity: .6

.footer-info
  display: block
  max-width: 309px


</style>



// WEBPACK FOOTER //
// src/views/includes/footer.vue